export const steps = [
  { id: 1, label: "Basic Info" },
  { id: 2, label: "Financial Info" },
];
